import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, normalizeClass as _normalizeClass, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "relative" }
const _hoisted_2 = {
  key: 0,
  class: "absolute z-10 mt-2 w-48 rounded-md bg-white dark:bg-gray-800 shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none"
}
const _hoisted_3 = { class: "py-1" }
const _hoisted_4 = ["onClick"]

import { ref, computed } from 'vue'
import { ChevronDown } from 'lucide-vue-next'

interface FilterOption {
	value: string
	label: string
}


export default /*@__PURE__*/_defineComponent({
  __name: 'FilterDropdown',
  props: {
    modelValue: {},
    label: {},
    options: {}
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit: __emit }) {

const props = __props

const emit = __emit

const isOpen = ref(false)

const selectedLabel = computed(() => {
	const option = props.options.find(opt => opt.value === props.modelValue)
	return option?.label
})

const toggleDropdown = () => {
  	isOpen.value = !isOpen.value
}

const selectOption = (option: FilterOption) => {
	emit('update:modelValue', option.value)
	isOpen.value = false
}

const closeDropdown = () => {
  	isOpen.value = false
}

return (_ctx: any,_cache: any) => {
  const _directive_click_outside = _resolveDirective("click-outside")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("button", {
      type: "button",
      onClick: toggleDropdown,
      class: _normalizeClass(["btn btn-secondary flex items-center space-x-2 p-[10px]", { 'bg-primary dark:bg-primary-dark': isOpen.value }])
    }, [
      _createElementVNode("span", null, _toDisplayString(selectedLabel.value || __props.label), 1),
      _createVNode(_unref(ChevronDown), {
        class: _normalizeClass(["h-4 w-4 transition-transform duration-200", { 'rotate-180': isOpen.value }])
      }, null, 8, ["class"])
    ], 2),
    (isOpen.value)
      ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.options, (option) => {
              return (_openBlock(), _createElementBlock("button", {
                key: option.value,
                type: "button",
                onClick: ($event: any) => (selectOption(option)),
                class: _normalizeClass(["block w-full text-left px-4 py-2 text-sm text-gray-700 dark:text-gray-200 hover:bg-gray-100 dark:hover:bg-gray-700 transition-colors", {
					'bg-primary-bg dark:bg-primary-dark-bg text-white dark:text-primary-dark': option.value === __props.modelValue
				}])
              }, _toDisplayString(option.label), 11, _hoisted_4))
            }), 128))
          ])
        ])), [
          [_directive_click_outside, closeDropdown]
        ])
      : _createCommentVNode("", true)
  ]))
}
}

})